export interface Essay {
  slug: string;
  title: string;
  subtitle: string;
  author: string;
  date: string; // ISO
  dateDisplay: string;
  dateModified?: string; // ISO
  dateModifiedDisplay?: string;
  readingMinutes: number;
  summary?: string; // Short "In short:" opener for AI-search citation
}

export const essays: Essay[] = [
  {
    slug: "the-second-loop",
    title: "The Second Loop",
    subtitle:
      "What the token capital era gets right, what it cannot see, and the asset no one can extract",
    author: "Kent H. Frazier",
    date: "2026-06-10",
    dateDisplay: "June 10, 2026",
    dateModified: "2026-07-10",
    dateModifiedDisplay: "July 10, 2026",
    readingMinutes: 8,
    summary:
      "AI's 'token capital' loop compounds what your people already knew. But the scarce asset — human judgment, taste, and trust — needs its own loop. Organizations that thrive will run both: extraction alongside development.",
  },
];

export const getEssay = (slug: string) => essays.find((e) => e.slug === slug);